import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { AppConfigService } from '@mos/client/shared/app-config'
import { AuthService } from '../../auth.service'

@Component({
	selector: 'mos-social-login',
	imports: [],
	templateUrl: './social-login.component.html',
	styleUrl: './social-login.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialLoginComponent {
	readonly authService = inject(AuthService)
	readonly appConfigService = inject(AppConfigService)

	async loginWithGoogle() {
		await this.authService.loginWithGoogle().catch(ignoreSocialLoginCancellation)
	}

	async loginWithApple() {
		await this.authService.loginWithApple().catch(ignoreSocialLoginCancellation)
	}
}

// The player closing/abandoning the Google or Apple sign-in isn't an error. Each SDK reports it its own way:
// web GIS ("Popup closed", { error: 'popup_closed_by_user' }, "OAuth timeout"), native Google ("The user
// canceled the sign-in flow."), native Apple (AuthorizationError 1001). Anything else is rethrown.
const SOCIAL_LOGIN_CANCELLATION = /popup.?closed|cancel|OAuth timeout|AuthorizationError error 1001/i

function ignoreSocialLoginCancellation(error: unknown): void {
	const message =
		error instanceof Error
			? error.message
			: typeof error === 'object' && error !== null && 'error' in error
				? String(error.error)
				: String(error)
	if (!SOCIAL_LOGIN_CANCELLATION.test(message)) throw error
}
